/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowTurnUpLeft: {
  name: 'arrow-turn-up-left';
  data: string;
} = {
  name: 'arrow-turn-up-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.354 2.646a.5.5 0 0 1 0 .708L2.207 6.5H14A1.5 1.5 0 0 1 15.5 8v5a.5.5 0 0 1-1 0V8a.5.5 0 0 0-.5-.5H2.207l3.147 3.146a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0Z" fill="currentColor"/></svg>`,
};
